import React, { useState, Fragment } from 'react';
import queryString from 'qs';
import Spinner from '../Spinner';
import Facets from '../Facets';
import withSearch from '../Containers/withSearch';
import classNames from 'classnames';
import ContentHistoryListItem from './list-item';
import Pagination from '../Pagination';
import ContentHistoryHeading from './content-history-heading';

const ContentHistoryList = (props) => {
  const [expandedFilter, setExpandedFilter] = useState();

  const toggleFacetsHandler = (e) => {
    e.target.classList.toggle('facets-open');

    setExpandedFilter(!expandedFilter);

    e.target.setAttribute('aria-expanded', expandedFilter);

    facetPanelHandler();
  };

  const facetPanelHandler = () => {
    const facets = document.querySelector('.content-history__facets');
    const facetPanel = document.querySelector(
      '.content-history__facets__panel'
    );
    const panelHeight = document
      .querySelector('.content-history__facets__panel-inner')
      .getBoundingClientRect().height;

    if (expandedFilter) {
      facetPanel.style.setProperty('height', `0px`);
      facets.classList.remove('facets-shown');
    } else {
      facetPanel.style.setProperty('height', `${panelHeight}px`);
      setTimeout(() => facets.classList.add('facets-shown'), 100);
    }
  };

  const isOnStartPage = (currentPage) => {
    if (currentPage.PageTypeName === 'StartPage') return true;
    return false;
  };

  const classes = classNames({
    'content-history': true,
    '.is-loading': props.SearchResult.isLoading,
    ...props.Modifiers,
  });

  const qs = queryString.parse(props.location.search, {
    ignoreQueryPrefix: true,
  });
  const { SinceDate, Translations, SearchResult, ShowInfo, ShowLoadMore } =
    props;
  const listItem =
    SearchResult &&
    SearchResult.SearchHits &&
    SearchResult.SearchHits.map((item, index) => (
      <ContentHistoryListItem
        lastListItemId={props.lastListItemId}
        key={index}
        largeList={!isOnStartPage(props.CurrentPageProps)}
        {...item}
        translations={Translations}
        isLast={index + 1 === SearchResult.SearchHits.length}
      />
    ));

  return (
    <div className={classes}>
      <ContentHistoryHeading {...props} />
      {ShowInfo && !isOnStartPage(props.CurrentPageProps) && (
        <Fragment>
          <div className="content-history__info-panel">
            <p>
              <strong>
                {SearchResult.TotalHits} {Translations.updates}
              </strong>{' '}
              {Translations.since} {SinceDate}
            </p>
            {props.Facets.Items.length > 0 && (
              <button
                className="content-history__filter-btn"
                aria-expanded={expandedFilter}
                aria-controls={props.UniqueBlockId}
                type="button"
                onClick={toggleFacetsHandler}
              >
                {Translations.filterlist}
              </button>
            )}
          </div>

          <div
            className="content-history__facets"
            id={props.UniqueBlockId}
            aria-hidden={!expandedFilter}
          >
            <div className="content-history__facets__panel">
              <form className="content-history__facets__panel-inner">
                <fieldset>
                  <legend className="show-for-sr">
                    {Translations.filterlist}
                  </legend>
                  <Facets
                    {...props}
                    queryString={qs}
                    pathname={props.location.pathname}
                  />
                </fieldset>
              </form>
            </div>
          </div>
        </Fragment>
      )}
      {listItem && <ul className="content-history__list">{listItem}</ul>}

      {ShowLoadMore && !isOnStartPage(props.CurrentPageProps) && (
        <div className="content-history__list__footer">
          <Pagination
            Modifiers={{ 'content-history__pagination': true }}
            onClick={() =>
              document.getElementById(props.lastListItemId).focus()
            }
            {...props.SearchResult}
            Spinner={
              <Spinner Modifiers={{ 'c-spinner--content-history': true }} />
            }
          >
            {props.SearchResult.BatchText}
          </Pagination>
        </div>
      )}
    </div>
  );
};

ContentHistoryList.defaultProps = {
  lastListItemId: 'search-list-last',
};

export default withSearch(ContentHistoryList, 'ContentHistoryList');
